/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserSubscription = /* GraphQL */ `
  mutation CreateUserSubscription(
    $input: CreateUserSubscriptionInput!
    $condition: ModelUserSubscriptionConditionInput
  ) {
    createUserSubscription(input: $input, condition: $condition) {
      owner
      tier
      hoursleft
      notesleft
      hoursSaved
      hoursSavedLifetime
      isActivated
      has3Notes
      has5Notes
      __typename
    }
  }
`;
export const updateUserSubscription = /* GraphQL */ `
  mutation UpdateUserSubscription(
    $input: UpdateUserSubscriptionInput!
    $condition: ModelUserSubscriptionConditionInput
  ) {
    updateUserSubscription(input: $input, condition: $condition) {
      owner
      tier
      hoursleft
      notesleft
      hoursSaved
      hoursSavedLifetime
      isActivated
      has3Notes
      has5Notes
      __typename
    }
  }
`;
export const deleteUserSubscription = /* GraphQL */ `
  mutation DeleteUserSubscription(
    $input: DeleteUserSubscriptionInput!
    $condition: ModelUserSubscriptionConditionInput
  ) {
    deleteUserSubscription(input: $input, condition: $condition) {
      owner
      tier
      hoursleft
      notesleft
      hoursSaved
      hoursSavedLifetime
      isActivated
      has3Notes
      has5Notes
      __typename
    }
  }
`;
export const createNotes = /* GraphQL */ `
  mutation CreateNotes(
    $input: CreateNotesInput!
    $condition: ModelNotesConditionInput
  ) {
    createNotes(input: $input, condition: $condition) {
      owner
      timestamp
      transcript
      note
      isCompleted
      noteLabel
      __typename
    }
  }
`;
export const updateNotes = /* GraphQL */ `
  mutation UpdateNotes(
    $input: UpdateNotesInput!
    $condition: ModelNotesConditionInput
  ) {
    updateNotes(input: $input, condition: $condition) {
      owner
      timestamp
      transcript
      note
      isCompleted
      noteLabel
      __typename
    }
  }
`;
export const deleteNotes = /* GraphQL */ `
  mutation DeleteNotes(
    $input: DeleteNotesInput!
    $condition: ModelNotesConditionInput
  ) {
    deleteNotes(input: $input, condition: $condition) {
      owner
      timestamp
      transcript
      note
      isCompleted
      noteLabel
      __typename
    }
  }
`;
